import React, { useState } from "react";
import { IonButton, IonCard, IonIcon, IonItem, IonLabel, IonText } from "@ionic/react";
import { Message } from "../../@types/message";
import {
  documentTextOutline,
  chatbubblesOutline,
  searchCircleOutline,
  downloadOutline,
} from "ionicons/icons";
import UserAvatar from "../UserAvatar";
import api from "../../utils/api";

interface ComponentProps {
  message: Message;
  routerLink: string;
}

export const MessageItem: React.FC<ComponentProps> = ({ message: messageItem, routerLink }) => {
  const [downloadUrl, setDownloadUrl] = useState<string | null>(null);

  const handleDownload = async (archiveId: string) => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${api.baseURL}archive/${archiveId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        setDownloadUrl(url);

        // Simular clic en un enlace para descargar el archivo
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', messageItem.archive?.filename || 'file');
        document.body.appendChild(link);
        link.click();
        link.remove();
      } else {
        console.error('Error fetching document:', response.statusText);
      }
    } catch (error) {
      console.error('Fetch error:', error);
    }
  };

  return (
    <IonCard className="ion-no-margin ion-margin-bottom">
      <IonItem lines="none">
        <UserAvatar user={messageItem.createdBy} />
        <IonLabel>
          <h2 style={{ fontWeight: 500 }}>
            <IonText color="primary" style={{ fontWeight: 500, paddingRight: 5 }}>
              {messageItem.createdBy?.name}
            </IonText>
            <IonText color="dark">{messageItem.text}</IonText>
          </h2>
        </IonLabel>
        <IonText slot="end" className="ion-margin-end">
          <h5>{messageItem.createdAtLegible?.time}</h5>
        </IonText>
      </IonItem>
      {messageItem.comment && (
        <IonItem lines="none">
          <IonIcon slot="start"></IonIcon>
          <IonLabel>
            <p>
              <IonIcon icon={chatbubblesOutline} className="ion-margin-end"></IonIcon>
              <small>{messageItem.comment}</small>
            </p>
          </IonLabel>
        </IonItem>
      )}
      {messageItem.archive?.id && (
        <IonItem lines="none">
          <IonIcon slot="start"></IonIcon>
          <IonLabel>
            <p>
              <IonButton
                onClick={() => handleDownload(messageItem!.archive!.id!)}
                color="medium"
                fill="outline"
              >
                <IonIcon icon={documentTextOutline} slot="start"></IonIcon>
                <small>{messageItem.archive?.filename}</small>
                <IonIcon icon={downloadOutline} slot="end"></IonIcon>
              </IonButton>
            </p>
          </IonLabel>
        </IonItem>
      )}
      {messageItem.document && routerLink && (
        <IonItem lines="none">
          <IonIcon slot="start"></IonIcon>
          <IonLabel>
            <p>
              <IonButton routerLink={routerLink} color="medium" fill="outline">
                <IonIcon icon={documentTextOutline} slot="start"></IonIcon>
                <small>{messageItem.document?.title}</small>
                <IonIcon icon={searchCircleOutline} slot="end"></IonIcon>
              </IonButton>
            </p>
          </IonLabel>
        </IonItem>
      )}
    </IonCard>
  );
};
